import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp, Transform } from '@fortawesome/fontawesome-svg-core';
import classNames from 'classnames';
import React from 'react';
import { Button, ButtonProps } from 'react-bootstrap';

type IconButtonProps = ButtonProps & {
  icon: IconProp;
  iconalign?: 'left' | 'right' | 'middle';
  iconClassName?: string;
  transform?: string | Transform;
  children?: React.ReactNode;
};

const IconButton: React.FC<IconButtonProps> = ({
  icon,
  iconalign = 'left',
  iconClassName,
  transform,
  children,
  ...rest
}) => (
  <Button {...rest}>
    {iconalign === 'right' && children}
    <FontAwesomeIcon
      icon={icon}
      className={classNames(iconClassName, {
        'me-1': children && iconalign === 'left',
        'ms-1': children && iconalign === 'right',
      })}
      transform={transform}
    />
    {iconalign === 'left' || iconalign === 'middle' ? children : false}
  </Button>
);

export default IconButton;
